import React, { useEffect, useState } from "react";
import { Sparkles, Trash2, Plus, X } from "lucide-react";

const uid = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : String(Date.now() + Math.random());

const QuestionEditor = ({ question, onSave, onDelete, onRegenerate }) => {
  const [type, setType] = useState(question.type);
  const [text, setText] = useState(question.text);
  const [options, setOptions] = useState(Array.isArray(question.options) ? question.options : []);

  useEffect(() => {
    setType(question.type);
    setText(question.text);
    setOptions(Array.isArray(question.options) ? question.options : []);
  }, [question.id]);

  const setOpt = (id, patch) => setOptions((os) => os.map((o) => (o.id === id ? { ...o, ...patch } : o)));
  const setCorrect = (id) => {
    if (type === "multiple") {
      setOptions((os) => os.map((o) => (o.id === id ? { ...o, correct: !o.correct } : o)));
    } else {
      setOptions((os) => os.map((o) => ({ ...o, correct: o.id === id })));
    }
  };
  const addOpt = () => setOptions((os) => [...os, { id: uid(), text: "", correct: false }]);
  const removeOpt = (id) => setOptions((os) => os.filter((o) => o.id !== id));

  return (
    <div className="builder-block">
      <div className="builder-block-head">
        <select className="builder-input" style={{ width: "auto" }} value={type} onChange={(e) => setType(e.target.value)}>
          <option value="single">Choix unique</option>
          <option value="multiple">Choix multiple</option>
          <option value="boolean">Vrai / Faux</option>
        </select>
        <div className="builder-row" style={{ gap: 4 }}>
          <button className="ai-btn icon-only" title="Régénérer la question" onClick={onRegenerate}>
            <Sparkles size={15} />
          </button>
          <button className="greenButton" onClick={() => onSave({ type, text, options })}>
            Enregistrer
          </button>
          <button className="icon-btn danger" title="Supprimer la question" onClick={onDelete}>
            <Trash2 size={15} />
          </button>
        </div>
      </div>

      <input
        className="builder-input"
        placeholder="Intitulé de la question"
        value={text}
        onChange={(e) => setText(e.target.value)}
        style={{ margin: "8px 0" }}
      />

      {options.map((o) => (
        <div className="quiz-option-row" key={o.id}>
          <input
            type={type === "multiple" ? "checkbox" : "radio"}
            checked={!!o.correct}
            onChange={() => setCorrect(o.id)}
          />
          <input
            className="builder-input"
            value={o.text}
            placeholder="Réponse"
            onChange={(e) => setOpt(o.id, { text: e.target.value })}
            style={{ flex: 1 }}
          />
          <button className="icon-btn danger" title="Retirer l'option" onClick={() => removeOpt(o.id)}>
            <X size={14} />
          </button>
        </div>
      ))}
      <button className="mini-btn" onClick={addOpt} style={{ marginTop: 4 }}>
        <Plus size={14} /> Option
      </button>
    </div>
  );
};

const QuizEditor = ({ quiz, onAddQuestion, onSaveQuestion, onDeleteQuestion, onRegenerateQuestion, onRegenerateQuiz }) => {
  const questions = [...(quiz.FormationQuestions || [])].sort((a, b) => a.order - b.order);

  return (
    <div>
      <div className="builder-section-head">
        <h2 style={{ flex: 1, fontSize: 18 }}>{quiz.title}</h2>
        <button className="ai-btn" onClick={onRegenerateQuiz}>
          <Sparkles size={15} /> Régénérer le quizz
        </button>
      </div>

      {questions.length === 0 && <p className="builder-empty">Aucune question. Ajoutez-en une ci-dessous.</p>}

      {questions.map((q) => (
        <QuestionEditor
          key={`${q.id}:${q.updatedAt}`}
          question={q}
          onSave={(fields) => onSaveQuestion(q.id, fields)}
          onDelete={() => onDeleteQuestion(q.id)}
          onRegenerate={() => onRegenerateQuestion(q.id)}
        />
      ))}

      <button className="mini-btn" onClick={onAddQuestion} style={{ marginTop: 10 }}>
        <Plus size={14} /> Ajouter une question
      </button>
    </div>
  );
};

export default QuizEditor;
